import apiGetRequest from './base/api-get-request'

const getPublicTenantConfig = (slug) => {
    return apiGetRequest(`/public-tenant-config?slug=${slug}&domain=${document.location.hostname}`)()
}

export default getPublicTenantConfig